// 项目设置模块
export default {
    SetUp: {
        AnswerSet: 'Set jawapan',
        QualitySettings: 'Tetapan Kualiti',
        PublicSettings: 'Tetapan Umum',
        OtherSettings: 'Tetapan lain-lain',
        CanOnly: 'Hanya boleh',
        EveryHour: 'Setiap jam',
        EveryDay: 'Setiap hari',
        Weekly: 'Setiap minggu',
        Monthly: 'Setiap bulan',
        Thanking: 'Jawapan anda telah dihantar, terima kasih kerana mengambil bahagian dalam soal selidik ini!',
        OnlyWeChatAnswerQuestions: 'Hanya Wechat dibenarkan untuk menjawab soal selidik',
        WeChatRestrictions: 'Had bilangan untuk Wechat menjawab soal selidik',
        PleaseSelect: 'Sila pilih',
        Answer: 'Jawab',
        PleaseEnterContent: 'Sila masukkan kandungan',
        Times: 'Kali',
        ComputerOrPhoneRestrictions: 'Had bilangan untuk komputer atau telefon bimbit menjawab soal selidik',
        IPRestrictions: 'Had bilangan untuk satu IP menjawab soal selidik',
        ActivateAccessPassword: 'Aktifkan kata laluan askes',
        EnterTheAccessPassword: 'Sila masukkan kata laluan askes',
        MailOnly: 'Hanya penerima emel boleh menjawab soal selidik',
        SetTime: 'Tetapkan masa permulaan/tutup',
        SetStartTime: 'Tetapkan masa permulaan',
        NoRestrictions: 'Tiada had',
        SetEndTime: 'Tetapkan masa tutup',
        EndTimeGreaterThanStartTime: 'Masa tutup hendaklah lebih lewat daripada masa permulaan',
        SetDataUpperLimit: 'Tetapkan had atas data jawapan',
        Collect: 'Kumpulkan',
        EndOfData: 'Data akhir',
        ControlPageFillingTime: 'Kawal masa untuk mengisis halaman',
        Limitation: 'Had',
        TimedOutAutomaticSubmission: 'Lengkapkan soal selidik dalam beberapa minit, dan serahkan semua kandungan secara automatik selepas tamat masa',
        SetQuotas: 'Tetapkan kuota',
        PublicSettings: 'Tetapan Umum',
        ShareButton: 'Paparkan butang "Kongsi" untuk berkongsi pautan ke lebih banyak laman rangkaian sosial (halaman jawapan komputer sahaja)',
        AnswerSquare: 'Sama ada menerbitkan ke Dataran Responden',
        OtherSettings: 'Tetapan yang lain-lain',
        CustomJump: 'Beralih tersuai selepas menjawab soalan',
        SettableVariables: 'Pembolehubah boleh ditetapkan, contohnya',
        QuestionnaireIdentification: 'ID soal selidik',
        UserId: 'ID Pengguna, Hanya sah untuk soalan log masuk',
        ThirdParty: 'ID sistem dok pihak ketiga, hanya sah untuk soalan dok',
        UniqueId: 'ID Unik untuk setiap responden"',
        Staging: 'Aktifkan penyimpanan sementara untul jawapan soal selidik',
        ThirdPartyTitle: 'Tetapan dok pihak ketiga',
        SatisfactionScore: 'Aktifkan ringkasan skor kepuasan',
        TotalScoreFormula: 'Formula Jumlah Markah',
        RandomSettings: 'Tetapan tersuai',
        DockingSettings: 'Tetapan dok',
        IsTheQuestionnaireValid: 'Soal selidiksah?',
        SetEffectiveTime: 'Tetatpkan masa efektif (hari)',
        SynchronizeSamples: 'Tetapan parameter sampel yang segerak',
        RuleSettings: 'Tetapan perturan soal selidik',
        SampleParameters: 'Tetapan parameter sampel ',
        Add: 'Tambah',
        FieldName: 'Nama medan data',
        EnglishName: 'Nama medan data di Bahasa Inggeris',
        Close: 'Tutup',
        PleaseEnterAFieldName: 'Sila masukkan nama medan data',
        PleaseEnterAnEnglishName: 'Sila masukkan nama medan data di Bahasa Inggeris',
        ReturnVisitChannels: 'Saluran susulan',
        FollowUpType: 'Jenis susulan',
        ValidOrNot: 'Sahkah?',
        DeleteIt: 'Padamkan?',
        AddRuleSettings: 'Tetapan penambahan pengaturan',
        RuleType: 'Jenis peraturan',
        SelectARuleType: 'Sila pilih jenis peraturan',
        RuleChannel: 'Saluran peraturan',
        SelectARuleChannel: 'Sila pilih saluran peraturan',
        EditQuestionnaireRuleSettings: 'Tetapan peraturan edit soal selidik',
        NameOfFollowUpVisit: 'Nama saluran susulan',
        RuleName: 'Nama peraturan',
        ModifyQuestionnaireRules: 'Tetpan pengubahsuaian peraturan soal selidik',
        WeChatSettings: 'Tetapan Wechat',
        QuerySettings: 'Tetapan pertanyaan',
        SampleSettings: 'Tetapan sampel',
        PrizesAndRedEnvelopes: 'Hadiah dan sampul merah',
        JumpToTheSpecifiedPage: 'Beralih ke laman tertentu (Contohnya: https://www.surveytree.org)',
        PleaseEnterTheAddress: 'Sila masukkan alamat',
        PleaseSelectWhetherItIsValid: 'Sila pilih sama ada sah atau tidak',
        DoNotSet: 'Tidak tetapkan',
        RandomizeByQuestion: 'Rawak berdasarkan soalan',
        RandomByPage: 'Rawak berdasarkan laman',
        PiecewiseRandom: 'Rawak berdasarkan segmen',
        NewlyAdded: 'Baru ditambah',
        StartingQuestion: 'Soalan permulaan',
        StartNum: 'Nombor soalan tidak boleh lebih kecil daripaad satu dan mesti lebih besar daripada jumlan soalan',
        ToTheEndQuestion: 'Sehingga ke soalan akhir',
        EndNum: 'Nombor soalan tidak boleh lebih kecil daripaad satu dan mesti lebih besar daripada jumlan soalan',
        Randomizing: 'Secara rawak',
        TheCurrentRangeOnlyHas:'Julat semasa hanya ada',
        Questions: 'Soalan',
        Question: 'Soalan',
        FromStartPage: 'Bemula dari laman permulaan',
        pageStartNum: 'Nombor halaman tidak boleh lebih kecial daripada satu and mesiti lebih besar daripada jumlah halaman',
        ToEndPage: 'Sehingga laman terakhir',
        PageEndNum: 'Nombor halaman tidak boleh lebih kecial daripada satu and mesiti lebih besar daripada jumlah halaman',
        Page: 'Halaman',
        Pages: 'Halaman',
        NumberOfQuestions: 'Bilangan nombor soalan',
        ShowOnlySomeTitlesOnThisPage: 'Hanya paparkan sebahagian tajuk di halaman ini',
        RandomFunction: 'Fungsi rawak',
        RemoveObstaclesFrom: 'Menyingkirkan halangan',
        TheCurrentPageHas: 'Halaman semasa mengandungi',
        Tip: 'Tip',
        CheckOn: 'Jikalau soal selidik mengandungi “Tetapan Logik”“Logik Perkaitan”“Logik Petikan”，tetapan secara rawak akan menyebabkan logik sebegini tidak sah,sila semak!',
        MoreThanTwoQuestions: 'Hanya soal selidik yang melebihi 2 soalan baru boleh memilih item ini',
        GotIt: 'Faham',
        OverTwoPages: 'Hanya soal selidik yang melebihi 2 halaman baru boleh memilih item ini',
        Yes: 'Ya',
        No: 'Tidak',
    },
  };